// extracted by mini-css-extract-plugin
module.exports = {"oqbyvuv":"oqbyvuv","w3dgo":"w3dgo","bp5n8u6":"bp5n8u6","bj2637l":"bj2637l"};